import BaseContainer from "@/components/baseContainer";
import { API_BASE_URL } from "@/config";
import { Application } from "@/types";
import { useEffect, useState, useMemo } from "react";
import { ClipLoader } from "react-spinners";

const EntryTable = () => {

  const [applications, setApplications] = useState<Application[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        if (!token) throw new Error("認証情報がありません");

        const appRes = await fetch(`${API_BASE_URL}/v1/user/application`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!appRes.ok) throw new Error("申請データの取得に失敗しました");

        const appData = await appRes.json();
        setApplications(appData);
      } catch (err) {
        console.error(err);
        setError("申請データの取得に失敗しました");
      } finally {
        setLoading(false);
      }
    };

    // 本番用
     fetchData();

    // ダミーデータここから
    // 不要になったら、この行は削除ください。（コメントアウトで残されてるとソースが見づらくなるので...）
    // setApplications([
    //   { id: 1, date: '2025/10/01 11:10', status: 'キャンセル', registerNumber: '123456-000003' },
    // ]);
    // ダミーデータここまで

  }, []);
  const regNo = applications?.[0]?.registerNumber?.trim() ?? "";

  const innerContent = useMemo(() => {
    if (loading) {
      return <div className="flex justify-center"><ClipLoader color="#000" loading={loading} /></div>;
    }
    if (error) {
      return <p className="text-gray-500">{error}</p>;
    }
    if (applications.length > 0) {
      return (
        <div className="m-entry-list">
          <dl>
            <dt>お申込み日時
                <p style={{ marginTop: "0rem", fontSize: "1.0rem", color: "#6b7280" }}>
                  &nbsp;
                </p>
            </dt>
            <dd>{applications[0].date}</dd>
          </dl>
          <dl>
            <dt>ステータス
                <p style={{ marginTop: "0rem", fontSize: "1.0rem", color: "#6b7280" }}>
                &nbsp;
                </p>
            </dt>
            <dd>{applications[0].status}<p></p></dd>
          </dl>
          <dl>
            <dt>利用登録番号
                <p style={{ marginTop: "0rem", fontSize: "1.0rem", color: "#6b7280" }}>
                  （モニタープログラムお申し込み時に必要です。）
                </p>
            </dt>
            <dd>
              <span>{regNo || "\u00A0"}</span>
            </dd>
          </dl>
        </div>
      )
    }
    return <p className="text-gray-500">利用登録のお申し込みはありません</p>;
  }, [loading, error, applications]);

  return (
    <div>
      {/* コンテナ外で横並びを作る */}
      <div className="sc-mypage-row">
        {/* 左：タイトル（コンテナ外・ページ背景のまま） */}
        <article className="sc-subpage sc-mypage-title">
          <header className="sc-subpage__header">
            <h1 className="sc-subpage__ttl">
              <span className="main">MY PAGE</span>
              <span className="sub">マイページ</span>
            </h1>
          </header>
        </article>
  
        {/* 右：白背景の BaseContainer（中身は既存のまま） */}
        <div className="sc-mypage-boxwrap">
          <BaseContainer className="xmd:w-[75rem] mr-0">
            <div>
              <p className="m-icon-title" style={{ color: 'var(--color-forest)' }}>
                <em className="m-icon-doc"></em>
                <span>利用登録お申し込み</span>
              </p>
              {innerContent}
            </div>
          </BaseContainer>
        </div>
      </div>
    </div>
  );
  
};

export default EntryTable;